import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    backgroundColor: theme.palette.colors.background,
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    height: '100vh',
  },
}));



// WEBPACK FOOTER //
// ./src/components/EmbedCalculator/useStyles.js